import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../../api/axiosInstance";

export const productQuickUpdateFunc = createAsyncThunk(
  "productQuickUpdateSlicer/productQuickUpdateFunc",
  async ({ productId, data }, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const response = await api.put(
        `dashboard/products/${productId}/quick-update`,
        data
      );
      return { productId, product: response.data?.data?.product };
    } catch (error) {
      return rejectWithValue({ productId, error: error.response?.data || error.message });
    }
  }
);

const productQuickUpdateSlicer = createSlice({
  name: "productQuickUpdateSlicer",
  initialState: { loadingIds: {}, errorByProduct: {} },
  reducers: {
    clearQuickUpdateError: (state, action) => {
      if (action.payload) {
        delete state.errorByProduct[action.payload];
      } else {
        state.errorByProduct = {};
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(productQuickUpdateFunc.pending, (state, action) => {
        const id = action.meta.arg.productId;
        state.loadingIds[id] = true;
        delete state.errorByProduct[id];
      })
      .addCase(productQuickUpdateFunc.fulfilled, (state, action) => {
        const id = action.payload.productId;
        delete state.loadingIds[id];
        delete state.errorByProduct[id];
      })
      .addCase(productQuickUpdateFunc.rejected, (state, action) => {
        const id = action.meta.arg?.productId;
        if (id) {
          delete state.loadingIds[id];
          state.errorByProduct[id] = action.payload;
        }
      });
  },
});

export const { clearQuickUpdateError } = productQuickUpdateSlicer.actions;
export default productQuickUpdateSlicer.reducer;
